import { combineReducers } from "redux";
import { shipmentSlice } from './Shipment.Slice';
import { statusSlice } from './Status.Slice';

export const rootReducer = combineReducers({
  shipment: shipmentSlice.reducer,
  statuses: statusSlice.reducer,

});
export * from './Shipment.Slice';
export * from './Status.Slice'; 